import { AxiosRequestConfig } from "axios";
import client from "libs/HttpClient";

/**
 * Represents the structure of a request for listing products.
 */
interface ListProductRequest {
  queryKey: [number, string, string];
}

/**
 * Service class for handling products.
 */
class ProductService {
  static listProduct(request: ListProductRequest) {
    const page_no = request.queryKey[0];
    const searchText = request.queryKey[1];
    const status = request.queryKey[2];

    return client.get(
      `admin/product/list?page=${page_no}&search_text=${searchText}&status=${status}`,
      request as AxiosRequestConfig
    );
  }

  /**
   * Adds a new product based on the provided request.
   *
   * @param request - The request parameters for adding a product.
   * @returns A Promise that resolves to the Axios response for the add product request.
   */
  static addProduct(request: any) {
    return client.post("admin/product/add", request, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  }

  /**
   * Updates the status of a product based on the provided request.
   *
   * @param request - The request parameters for updating the status of a product.
   * @returns A Promise that resolves to the Axios response for the update status request.
   */
  static updateStatusProduct(request: any) {
    return client.patch("admin/product/update-status/", request);
  }

  /**
   * Updates the details of a product based on the provided request.
   *
   * @param request - The request parameters for updating a product.
   * @returns A Promise that resolves to the Axios response for the update product request.
   */
  static updateProduct(request: any) {
    return client.post("admin/product/edit/", request, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  }

  /**
   * Retrieves the details of a product based on the provided parameters.
   *
   * @param params - The parameters for retrieving the product details.
   * @returns A Promise that resolves to the Axios response containing the product details.
   */
  static viewProduct(params: any) {
    return client.get("admin/product/get", { params });
  }

  /**
   * Deletes a product based on the provided parameters.
   *
   * @param params - The parameters for deleting the product.
   * @returns A Promise that resolves to the Axios response for the delete product request.
   */
  static deleteProduct(params: any) {
    return client.delete("/admin/product/delete/", { params });
  }

  /**
   * get Product Details based on the provided request.
   *
   * @param request - The request parameters for getting a product.
   * @returns A Promise that resolves to the Axios response for the update product request.
   */
  static getProductList(request: any) {
    return client.get("admin/product/product-list/", request);
  }

  /**
   * get Product List based on the provided request.
   *
   * @param request - The request parameters for getting a product.
   * @returns A Promise that resolves to the Axios response for the update product request.
   */
  static getProductListBySequence(request: any) {
    return client.get("admin/product/get-product-list/", request);
  }

  static getProductDetails(params: any) {
    return client.get(`admin/product/get-product-detail?product_id=${params}`);
  }
}

export { ProductService };
